import KBReposPanel from '@/components/kb/KBReposPanel';
import KBSourceMountsPanel from '@/components/kb/KBSourceMountsPanel';
import SourceConfigPanel from '@/components/kb/KBSourceConfigSection';

export default function KBOriginsPanel() {
  return (
    <div className="space-y-6" data-testid="kb-origins-panel">
      <SourceConfigPanel />
      <KBSourceMountsPanel />
      <KBReposPanel />
    </div>
  );
}
